const ErrorsService = {
	setFetchError (mutationName, context, error) {
		if (error.response) {
			var e = Array.isArray(error.response.data.errors) ? error.response.data.errors : [error.response.data.message]
			context.commit(mutationName, e)
		} else if (error.request) {
			context.commit(mutationName, ["Нет ответа от сервера"])
		} else {
			if (window.webpackHotUpdate === undefined) {
				context.commit(mutationName, ["При запросе произошла ошибка"])
			}
			else {
				context.commit(mutationName, [error])
			}
		}
	}
}

export default ErrorsService


// WEBPACK FOOTER //
// ./src/store/errors.service.js